
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      allPartners: [],
    };
  },
  computed: {
    partnerGroups () {
      return this.post.acf?.partner_index?.partner_groups;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getPartners();
    });
  },
  methods: {
    async getPartners () {
      const queryParams = {
        fields: `id,title,acf,image,slug`,
        posts: {
          post_type: `partner`,
          posts_per_page: 200,
          post_status: `publish`,
        },
        options: {
          image_size: `medium_large`,
        },
      };
      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.allPartners = request;
      }
    },
  },
};
